import { render, staticRenderFns } from "./ServiceItem.vue?vue&type=template&id=90d80214&scoped=true"
import script from "./ServiceItem.vue?vue&type=script&lang=ts"
export * from "./ServiceItem.vue?vue&type=script&lang=ts"
import style0 from "./ServiceItem.vue?vue&type=style&index=0&id=90d80214&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90d80214",
  null
  
)

export default component.exports